export const documentMaskMixin = {
  data: () => ({
    nomask: {
      mask: '*'.repeat(255),
      tokens: {
        '*': { pattern: /./ }
      }
    }
  }),
  computed: {
    isInternacionalModuleActive() {
      return Boolean(this.$store.getters.ALLOWED_MODULES.hotsite_international) && this.allowedCountries.length > 0
    },
    allowedCountries() {
      if (!this.$store.getters.ALLOWED_COUNTRIES || this.$store.getters.ALLOWED_COUNTRIES.length < 1) return []
      return this.$store.getters.ALLOWED_COUNTRIES.map(country => {
        switch (country) {
          case 'BRASIL':
            return { label: 'Brasil', icon: 'brasil.png', value: 'BRASIL' }
          case 'ARGENTINA':
            return { label: 'Argentina', icon: 'argentina.png', value: 'ARGENTINA' }
          case 'URUGUAY':
            return { label: 'Uruguai', icon: 'uruguai.png', value: 'URUGUAY' }
          default:
            return ''
        }
      })
    },
    selectedCountry() {
      return this.$store.getters.SELECTED_COUNTRY
    },
    isBrazilSelectedCountry() {
      if (!this.isInternacionalModuleActive) return true
      return this.selectedCountry === 'BRASIL'
    },
    documentMask() {
      const masksPerPersonType = {
        N: ['###.###.###-##'],
        L: ['##.###.###/####-##']
      }
      const masks = this.getAllowedPersonTypesSignups.reduce((allowedMasks, personType) => [...allowedMasks, ...masksPerPersonType[personType]], [])

      return this.isBrazilSelectedCountry ? masks : this.nomask
    },
    getAllowedPersonTypesSignups() {
      return this.$store.getters.GET_ALLOWED_PERSON_TYPES_SIGNUP || []
    }
  }
}
